
function formatDate(dateTime){
    let dateString = "Unknown";
    if(dateTime != undefined){
      var date = new Date(dateTime);
      dateString = date.toLocaleString();
    }
    return dateString;
  }

  export function formatJustDate(dateTime){
    let dateString = "Unknown";
    if(dateTime != undefined){
      var date = new Date(dateTime);
      dateString = date.toLocaleDateString();;
    }
    return dateString;
  }

  export default formatDate


  
